import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

export default defineNuxtPlugin(() => {
  const {echo: {wsAppKey, wsHost, wsPath, wsPort, wsScheme, wsAuthEndpoint}} = useAppConfig();

  const echo = new Echo({
    broadcaster: 'reverb',
    key: wsAppKey,
    wsHost: wsHost,
    wsPath: wsPath,
    wsPort: wsPort,
    wssPort: wsPort,
    forceTLS: wsScheme === 'https',
    enabledTransports: ['ws', 'wss'],
    Pusher: Pusher,
    authEndpoint: wsAuthEndpoint
  });

  return {
    provide: {
      echo,
      echoChannel: (channel: string) => echo.channel(channel)
    }
  };
});
